export const SDK_VERSION = '8.25.0';
